module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1003.bb55694f.png";